import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Content01 from "./content01";
import Content02 from "./content02";
import Content03 from "./content03";
import Content04 from "./content04";
import Content05 from "./content05";
import {driveNowPage} from '../../slices/counterSlice';
import {useDispatch} from "react-redux";
import {cardInfo, getorder} from "../../api/order";


export default function Index({match}) {
    const [state, setState] = useState(null);
    const [payLoad, setPayLoad] = useState(null);
    const [cardPayload, setCardPayload] = useState(null);
    // let orderNo = useSelector((state) => state.counter.data.orderNo);
    const { orderNo } = useParams();
    const dispatch = useDispatch();



    useEffect(() => {
        cardCall();
        orderCall();
    }, [])

    const cardCall = async() => {
        await cardInfo(orderNo).then(res => {
            setCardPayload(res.data.payLoad);
        }).catch(err => {
            console.log(err)
        })
    }
    const orderCall = async() => {
        await getorder(orderNo).then(res => {
            setState(res.data.payLoad.order.state);
            setPayLoad(res.data.payLoad.order);
        }).catch(err => {
            console.log(err)
            window.location.replace('/*')
        });
    }

    if(state === 1) {
        dispatch(driveNowPage('01'))
    } else if (state === 2 || state === 3 || state === 4) {
        dispatch(driveNowPage('02'))
    } else if (state === 5 && cardPayload === null) {
        dispatch(driveNowPage('03'))
    } else if (state === 5 && cardPayload !== null) {
        dispatch(driveNowPage('04'))
    } else if (state === 6) {
        dispatch(driveNowPage('99'))
    }


    return (
        <>
            {state === 1 &&
                <Content01 payload={payLoad}/>
            }
            {(state === 2 || state === 3 || state === 4) &&
                <Content02 payload={payLoad}/>
            }
            {(state === 5 && cardPayload === null) &&
                <Content03 payload={payLoad}/>
            }
            {(state === 5 && cardPayload !== null) &&
                <Content04 payload={payLoad} cardPayload={cardPayload}/>
            }
            {state === 6 &&
                <Content05 payload={payLoad} cardPayload={cardPayload}/>
            }

        </>
    )
}